function Header() {
	return (
		<nav className="navbar navbar-expand-lg navbar-dark justify-content-between" style={{backgroundColor: '#333'}}>
            <ul className="navbar-nav me-2">
                <a className="navbar-brand" href="/profile" style={{display: 'inline-block', minWidth: '200px', height: '65px'}}>
                    <img src="/logo.svg" alt="DATAtalent Job Portal" style={{height: '52px', width: 'auto', display: 'block'}} />
                </a>
            </ul>
        </nav>
	);
}

export default Header;